import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=cab3aa62&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/evyd/Prod/client-unn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cab3aa62"]])

export default __exports__